// Opens the generated invoice in a new tab AND saves a copy to disk.
//
// The backend returns two short-lived presigned S3 links for the same object:
//   invoiceUrl         - Content-Disposition: inline     (renders in a tab)
//   invoiceDownloadUrl - Content-Disposition: attachment (browser saves it)
//
// The attachment link is used for saving because an <a download> attribute is
// ignored for cross-origin URLs, and fetching the PDF as a blob would require
// CORS to be configured on the bucket. Letting S3 send the attachment header
// avoids both problems.

/**
 * @param {Object} data the submit response body
 * @param {Object} [opts] { open: boolean, save: boolean }
 */
export function openAndSaveInvoice(data, opts = {}) {
  const { open = true, save = true } = opts;
  if (!data) return;

  const viewUrl = data.invoiceUrl;
  const downloadUrl = data.invoiceDownloadUrl || data.invoiceUrl;

  if (open && viewUrl) {
    window.open(viewUrl, '_blank');
  }

  if (save && downloadUrl) {
    // A hidden anchor click keeps the current page intact; S3's attachment
    // header is what actually triggers the save.
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.rel = 'noopener';
    // Use the document's own filename (e.g. Payment_Details_&Agreement_UP44BF1766.pdf),
    // never the invoice number or the S3 key. For cross-origin URLs the browser
    // ignores this and uses the filename S3 sends, which is the same value.
    if (data.invoiceFileName) {
      a.download = data.invoiceFileName;
    }
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export default openAndSaveInvoice;
